import axios from "axios";
import { apiUrl, apiTokenRequest } from "../authconfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const apiClient = axios.create({
  baseURL: apiUrl,
});

let _msalInstance = null;
let _account = null;

export function initApiClient(msalInstance, account) {
  _msalInstance = msalInstance;
  _account = account;
}

apiClient.interceptors.request.use(async (config) => {
  if (!_msalInstance || !_account) {
    return config;
  }

  try {
    const response = await _msalInstance.acquireTokenSilent({
      ...apiTokenRequest,
      account: _account,
    });
    config.headers.Authorization = `Bearer ${response.accessToken}`;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      const response = await _msalInstance.acquireTokenPopup({
        ...apiTokenRequest,
        account: _account,
      });
      config.headers.Authorization = `Bearer ${response.accessToken}`;
    }
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    // #region agent log
    try {
      const st = error?.response?.status;
      const acao = error?.response?.headers?.["access-control-allow-origin"];
      fetch("http://127.0.0.1:7900/ingest/88dd56c3-ffb7-4b52-a2d7-3ae71854e4e6", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Debug-Session-Id": "946d07" },
        body: JSON.stringify({
          sessionId: "946d07",
          hypothesisId: "H1-H3",
          location: "apiClient.js:response_error",
          message: "axios_api_error",
          data: {
            url: String(error?.config?.url || ""),
            status: st ?? null,
            accessControlAllowOrigin: acao ?? null,
            code: error?.code || null,
          },
          timestamp: Date.now(),
        }),
      }).catch(() => {});
    } catch (_) {}
    // #endregion
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry && _msalInstance && _account) {
      originalRequest._retry = true;
      try {
        const response = await _msalInstance.acquireTokenSilent({
          ...apiTokenRequest,
          account: _account,
          forceRefresh: true,
        });
        originalRequest.headers.Authorization = `Bearer ${response.accessToken}`;
        return apiClient(originalRequest);
      } catch {
        // Token refresh failed — let the 401 propagate
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
